/*=========================================================================================
  File Name: moduleEmail.js
  Description: Email Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleLearningCenterState.js'
import mutations from './moduleLearningCenterMutations.js'
import actions from './moduleLearningCenterActions.js'
import getters from './moduleLearningCenterGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
